import { memo, useCallback, useEffect, useRef } from "react";
import { Box, Link, Skeleton } from "@mui/material";
import styled from 'styled-components';
import Loader from "../../pages/Loader";
import EmptyChartNew from "../../layouts/ReportLayout/EmptyChartNew";
import { CustomTooltip2, createMarkup, formatTableData, formatValue, resizableGrid } from "../../utils/Reusables";
import { Table } from "antd";


const TableChart = ({ resultSet, isLoading, changeCurrentPage, currPage, handlePrevData, prevData, reportDetails, query, updateQuery }) => {
  const tableRef = useRef()
  //console.log(reportDetails)
  const groupFlag = reportDetails.fields.filter(obj => obj.fieldType == 'DIMENSION' && obj.group).length
  const pivotConfig = {
    x: reportDetails.fields.filter(obj => obj.fieldType == 'DIMENSION' && !obj.group).map(obj => obj.member),
    y: [...reportDetails.fields.filter(obj => obj.fieldType == 'DIMENSION' && obj.group).map(obj => obj.member), ...reportDetails.fields.filter(obj => obj.fieldType == 'MEASURE' && !obj.group).map(obj => obj.member)],
    fillMissingDates: false
  }

  const formatColumn = useCallback((columns, fields) => {
    return fields.map((obj, index) => {
      if (obj.children) {
        let field = fields.find(elem => elem.group)
        obj.children = obj.children.map(childObj => {
          let childField = fields.find(elem => elem.member == childObj.key)
          childObj = { ...childObj, ...childField, title: childField.displayName, member: childObj.dataIndex }
          return childObj
        })
        obj = { ...obj, ...field, displayName: obj.key, title: obj.key }
      } else {
        let field = fields.find(elem => elem.member == obj.key)
        obj = { ...obj, ...field, title: field.displayName, member: obj.dataIndex }
      }
      return obj
    })
  })

  const tableColumns = groupFlag ? formatColumn(resultSet.tableColumns(pivotConfig), JSON.parse(JSON.stringify(reportDetails.fields))) : reportDetails.fields
  const totalRecords = resultSet?.loadResponse?.results?.[0]?.total
  const findSortCriteria = useCallback((fieldName) => {
    for (let i = 0; i < query.order.length; i++) {
      let criteria = query.order[i];
      if (criteria[0] === fieldName) {
        return { index: i, sort: criteria[1] }
      }
    }
    return { index: -1, sort: null }
  })

  const handleSort = useCallback((column) => {
    let fieldDetail = findSortCriteria(column.member)
    query.order.splice(fieldDetail.index, 1);
    const sortOrder = fieldDetail.sort === 'asc' ? 'desc' : 'asc';
    updateQuery({ order: [[column.member, sortOrder], ...query.order] })
  })

  const currentSortedField = query.order[0]
  const handleScroll = useCallback((e) => {
    const bottom = ((Math.ceil(e.target.scrollHeight - e.target.scrollTop) === e.target.clientHeight) || (Math.ceil(e.target.scrollHeight - e.target.scrollTop) === (e.target.clientHeight + 1)) || (Math.ceil(e.target.scrollHeight - e.target.scrollTop) === (e.target.clientHeight + 2)))
    if (bottom && !isLoading && resultSet.tablePivot(pivotConfig).length > 0 && resultSet.tablePivot(pivotConfig).length == query.limit) {
      handlePrevData(tablePivots)
      updateQuery({ offset: ((currPage + 1) * query.limit) })
      changeCurrentPage((currPage + 1))
    }
  })

  if (prevData.length == 0 && !resultSet && ((query.measures && query.measures.length == 0) && (query.dimensions && query.dimensions.length == 0))) {
    return <EmptyChartNew />
  }
  let tablePivots = prevData
  if (!isLoading) {
    tablePivots = [...prevData, ...resultSet.tablePivot(pivotConfig)]
  }
  //console.log(tableColumns,tablePivots)

  return <Box >
    <div >
      <div >
          {
            <Table 
              onScroll={handleScroll} 
              pagination={false} 
              sticky={true} 
              columns={
                tableColumns.filter(obj => !obj.hidden && !obj.concated)
                .map(
                  obj => {
                    return {
                      title:obj.displayName,
                      dataIndex:obj.dataIndex ?? obj.member,
                      width:obj.width ?? 'auto',
                      align: obj.align,
                      truncateCount:obj.truncateCount,
                      render:(_,record) => {
                        //console.log(record)
                        let formattedVal = formatValue(obj,record,reportDetails.fields)
                        if(typeof formattedVal === 'object' && formattedVal != null){
                          return <CustomTooltip2
                                    placement="left"
                                    overlayClassName="re-ant-tooltip"
                                    title={formattedVal.slice((obj.truncateCount), formattedVal.length).join(`   |   `)} >
                                    <span className=''>
                                      {formattedVal.slice(0, obj.truncateCount).join(',')}
                                      {
                                        (formattedVal.length - obj.truncateCount) > 0 &&
                                        <Link underline="hover">
                                          {`+${formattedVal.length - obj.truncateCount} more`}
                                        </Link>
                                      }
                                    </span>
                                  </CustomTooltip2>
                        }else{
                          return formattedVal
                        }                        
                      }
                    }
                })
              } 
              dataSource={tablePivots}
              scroll={{ y: 400 }} 
            />
          }
          {
            prevData.length > 1 && isLoading &&
            <div style={{ position: "relative" }}>
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 99999, opacity: 0 }} />
              <Loader />
            </div>
          }
        {/*<div className="ext-Custom-table">          
          {
            <table ref={tableRef} >
              <thead>
                {
                  groupFlag < 1 &&
                  <tr key={`thead-tr`}>
                    {tablePivots.length != 1 && <th width="10%" align={'right'} className="ant-table-cell ant-table-column-sort " key={'serialNo'}><div className="ant-table-column-sorters">#</div></th>}
                    {
                      tableColumns.filter(obj => !obj.hidden && !obj.concated).map(column => (
                        <th key={column.name} width={column.width ?? 'auto'} align={column.align ?? 'left'} className="ant-table-cell ant-table-column-sort ant-table-column-has-sorters" tabIndex={0}>
                          <div className="ant-table-column-sorters" onClick={e => handleSort(column)}>
                            <span className="ant-table-column-title">{column.displayName}</span>
                            <span className="ant-table-column-sorter ant-table-column-sorter-full">
                              <span className="ant-table-column-sorter-inner">
                                <span role="presentation" aria-label="caret-up" className={(currentSortedField && currentSortedField[0] == column.member && currentSortedField[1] == 'asc') ? `anticon anticon-caret-up ant-table-column-sorter-up active` : `anticon anticon-caret-up ant-table-column-sorter-up`}>
                                  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
                                  </svg>
                                </span>
                                <span role="presentation" aria-label="caret-down" className={(currentSortedField && currentSortedField[0] == column.member && currentSortedField[1] == 'desc') ? `anticon anticon-caret-down ant-table-column-sorter-down active` : `anticon anticon-caret-down ant-table-column-sorter-down`}>
                                  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
                                  </svg>
                                </span>
                              </span>
                            </span>
                          </div>
                        </th>
                      ))
                    }
                  </tr>
                }
                {
                  groupFlag > 0 && <>
                  <tr key={`thead-tr-1`}>
                    {tablePivots.length != 1 && <th width="10%" align={'right'} rowSpan={3} className="ant-table-cell ant-table-column-sort " key={'serialNo'}><div className="ant-table-column-sorters">#</div></th>}
                    {
                      tableColumns.filter(obj => !obj.hidden && !obj.concated).map(column => (                      
                        !column.group && <th key={`${column.key}-${column.member}`} rowSpan={3} width={column.width ?? 'auto'} align={column.align ?? 'left'} className="ant-table-cell ant-table-column-sort ant-table-column-has-sorters" tabIndex={0}>
                          <div className="ant-table-column-sorters" onClick={e => handleSort(column)}>
                            <span className="ant-table-column-title">{column.displayName}</span>
                            <span className="ant-table-column-sorter ant-table-column-sorter-full">
                              <span className="ant-table-column-sorter-inner">
                                <span role="presentation" aria-label="caret-up" className={(currentSortedField && currentSortedField.length > 0 && currentSortedField[0] == column.member && currentSortedField[1] == 'asc') ? `anticon anticon-caret-up ant-table-column-sorter-up active` : `anticon anticon-caret-up ant-table-column-sorter-up`}>
                                  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
                                  </svg>
                                </span>
                                <span role="presentation" aria-label="caret-down" className={(currentSortedField && currentSortedField.length > 0 && currentSortedField[0] == column.member && currentSortedField[1] == 'desc') ? `anticon anticon-caret-down ant-table-column-sorter-down active` : `anticon anticon-caret-down ant-table-column-sorter-down`}>
                                  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
                                  </svg>
                                </span>
                              </span>
                            </span>
                          </div>
                        </th>                                                
                      ))
                    }
                    {
                      reportDetails.fields.filter(obj => obj.group).map(column => {
                        let pivotField = tableColumns.filter(elem => !elem.dataIndex);
                        return <th key={column.member} colSpan={pivotField.length * pivotField[0].children.length} width={column.width ?? 'auto'} align={'center'}>
                          <div className="ant-table-column-sorters" onClick={e => handleSort(column)}>
                            <span className="ant-table-column-title">{column.displayName}</span>
                            <span className="ant-table-column-sorter ant-table-column-sorter-full">
                              <span className="ant-table-column-sorter-inner">
                                <span role="presentation" aria-label="caret-up" className={(currentSortedField && currentSortedField.length > 0 && currentSortedField[0] == column.member && currentSortedField[1] == 'asc') ? `anticon anticon-caret-up ant-table-column-sorter-up active` : `anticon anticon-caret-up ant-table-column-sorter-up`}>
                                  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
                                  </svg>
                                </span>
                                <span role="presentation" aria-label="caret-down" className={(currentSortedField && currentSortedField.length > 0 && currentSortedField[0] == column.member && currentSortedField[1] == 'desc') ? `anticon anticon-caret-down ant-table-column-sorter-down active` : `anticon anticon-caret-down ant-table-column-sorter-down`}>
                                  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
                                  </svg>
                                </span>
                              </span>
                            </span>
                          </div>
                        </th>
                      })
                    }
                  </tr>
                  <tr key={`thead-tr-2`}>
                    {
                      tableColumns.filter(obj => obj.group).map(column => (
                        <th key={`1-${column.key}-${column.member}`} colSpan={column.children.length}>
                          <div>
                            <span className="ant-table-column-title">{column.displayName}</span>
                          </div>
                        </th>
                      ))
                    }
                  </tr>
                  <tr key={`thead-tr-3`}>
                    {
                      tableColumns.filter(obj => obj.children).map(column => (
                        column.children.map(colObj => (
                          <th key={`child-${column.member}-${colObj.dataIndex}`}>
                            <div>
                              <span className="ant-table-column-title">{colObj.displayName}</span>
                            </div>
                          </th>
                        ))
                      ))
                    }
                  </tr>
                  </>
                }
              </thead>
              <tbody onScroll={handleScroll}>
                {
                  tablePivots.map((obj,i) => (                      
                      <tr key={`tbody-${i}`} className="ant-table-row ant-table-row-level-0">
                        {tablePivots.length != 1 && <td width="10%" className="ant-table-cell" align={'right'} key={'serialNoVal'}><div className="re-table-cell">{i + 1}</div></td>}
                        {
                          tableColumns.filter(obj => !obj.hidden && !obj.concated).map((column, i) => {
                            if(column.children){
                              return column.children.map(childObj => {
                                  let dataObj = {
                                    formatedValue: formatValue(childObj,obj,reportDetails.fields),
                                    rawValue: obj[childObj.member],
                                    width:childObj.width,
                                    align:childObj.align,
                                    truncateCount: childObj.truncateCount
                                  }
                                  return <td key={`${childObj.member}-${dataObj.rawValue}`} width={dataObj.width ? `${dataObj.width}%`: `auto`} align={dataObj.align} className="ant-table-cell">
                                      <div className="re-table-cell">
                                        {
                                          (typeof dataObj.formatedValue === 'object' && dataObj.formatedValue != null) &&
                                          <CustomTooltip2
                                            placement="left"
                                            overlayClassName="re-ant-tooltip"
                                            title={dataObj.formatedValue.slice((dataObj.truncateCount), dataObj.formatedValue.length).join(`   |   `)} >
                                            <span className=''>
                                              {dataObj.formatedValue.slice(0, dataObj.truncateCount).join(',')}
                                              {
                                                (dataObj.formatedValue.length - dataObj.truncateCount) > 0 &&
                                                <Link underline="hover">
                                                  {`+${dataObj.formatedValue.length - dataObj.truncateCount} more`}
                                                </Link>
                                              }
                                            </span>
                                          </CustomTooltip2>
                                        }

                                        {
                                          (typeof dataObj.formatedValue != 'object' || dataObj.formatedValue == null) ? dataObj.formatedValue :''
                                        }
                                      </div>
                                  </td>
                              })
                            }else{
                              let dataObj = {
                                formatedValue: formatValue(column,obj,reportDetails.fields),
                                rawValue: obj[column.member],
                                width:column.width,
                                align:column.align,
                                truncateCount: column.truncateCount
                              }
                              return <td key={`${column.member}-${dataObj.rawValue}`} width={dataObj.width ? `${dataObj.width}%`: `auto`} align={dataObj.align} className="ant-table-cell">
                                      <div className="re-table-cell">
                                        {
                                          (typeof dataObj.formatedValue === 'object' && dataObj.formatedValue != null) &&
                                          <CustomTooltip2
                                            placement="left"
                                            overlayClassName="re-ant-tooltip"
                                            title={dataObj.formatedValue.slice((dataObj.truncateCount), dataObj.formatedValue.length).join(`   |   `)} >
                                            <span className=''>
                                              {dataObj.formatedValue.slice(0, dataObj.truncateCount).join(',')}
                                              {
                                                (dataObj.formatedValue.length - dataObj.truncateCount) > 0 &&
                                                <Link underline="hover">
                                                  {`+${dataObj.formatedValue.length - dataObj.truncateCount} more`}
                                                </Link>
                                              }
                                            </span>
                                          </CustomTooltip2>
                                        }

                                        {
                                          (typeof dataObj.formatedValue != 'object' || dataObj.formatedValue == null) && dataObj.formatedValue
                                        }
                                      </div>
                                  </td>
                            }                           
                          })
                        }
                      </tr>
                  ))
                }                
              </tbody>
            </table>
          }
          
        </div>*/}
        {
          !groupFlag && totalRecords &&
          <div style={{ textAlign: 'right' }} dangerouslySetInnerHTML={createMarkup(tablePivots.length == totalRecords ? (totalRecords === 1 ? '' : `<p>Showing all <strong>${totalRecords}</strong> Records</p>`) : `<p>Showing <strong>${tablePivots.length}</strong> of <strong>${totalRecords}</strong> Records</p>`)} />
        }
      </div>

    </div>
  </Box>
}

export default memo(TableChart)